import React, { useRef } from "react";

// Components
import { useMutation } from "react-query";
import { useHistory, useParams } from "react-router";

import { ErrorAlert, ProductCsvUpload } from "@secondcloset/web-components";

import { notification } from "antd";

// Hooks
import { fetchAndDownloadCsvTemplate } from "../../../api/fulfillment/downloadCSV";

// api
import { useProductsCSVUpload } from "../../../hooks/api/fulfillment/uploadProductsCSV";

const ProductCsvUploadPage = () => {
  const pageRef = useRef<HTMLDivElement>(null);
  const history = useHistory();
  const params: { organization_id: string } = useParams();
  const { productsCSV, uploadProductsCSV } = useProductsCSVUpload();
  const { mutate: fetchCSVTemplate } = useMutation(fetchAndDownloadCsvTemplate);
  const organizationID = params?.organization_id || "";

  return (
    <div ref={pageRef} className="page-container">
      <ErrorAlert error={productsCSV.timeoutError} />
      <ProductCsvUpload
        onProductOverviewClick={() => history.push(`/organizations/${organizationID}/products`)}
        onDownloadClick={() =>
          pageRef.current && fetchCSVTemplate({ key: "fulfillment_create_products", node: pageRef.current })
        }
        onUploadClick={async (file) => {
          const result = await uploadProductsCSV(organizationID, file);
          if (!result) return;
          notification.success({
            message: "Success",
            description: `${result?.data?.number_of_products_created || ""} Product(s) created!`,
          });
          history.push(`/organizations/${organizationID}/products`);
        }}
        uploadErrors={productsCSV.errors}
        loading={productsCSV.loading}
      />
    </div>
  );
};

export default ProductCsvUploadPage;
